export default "c330d59f3e64e07a.ttf"